<template>
  <v-container fluid class="import-form mt-3 mx-1">
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <h2 class="primary--text font-weight-bold pt-5 pl-2">
            {{ $t('book/admin:import.title') }}
          </h2>
          <v-card
              elevation="0"
              flat
              tile
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-btn
                      :disabled="viewImport"
                      color="primary"
                      class="mr-3 mb-3 mb-md-0 white--text"
                      rounded
                      elevation="0"
                      @click="startViewDisplayImport()"
                  >
                    {{ $t('book/admin:import.btns.display-import') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card
              elevation="0"
              flat
              tile
              class="pl-3 pt-3 pb-md-3"
          >
            <v-card-text>
              <v-form ref="excelForm">
                <v-file-input
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    :label="$t('book/admin:import.file-excel')"
                    show-size
                    v-model="file"
                    :rules="[ruleRequired($t('utils:rules.requiredFile'))]"
                />

                <v-btn
                    :disabled="viewImport"
                    class="mr-3 mb-3 mb-md-0 white--text"
                    color="primary"
                    rounded
                    elevation="0"
                    @click="startExcelImport()"
                >
                  {{ $t('book/admin:import.btns.excel-import') }}
                </v-btn>

              </v-form>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card
              elevation="0"
              flat
              tile
              class="pl-3 pt-3 pb-md-3"
          >
            <v-btn
                color="grey"
                class="mr-3 mb-3 mb-md-0 white--text"
                rounded
                elevation="0"
                @click="$router.go(-1)"
            >{{ $t('buttons:back') }}
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import ImportService from "@/modules/book/services/import-service";
import Utils from "@/modules/core/services/utils";
import {ruleRequired} from "@/modules/core/services/rules";

export default {
  name: "ImportForm",
  components: {
  },
  data() {
    return {
      viewImport: false,
      file: null
    }
  },
  methods: {
    ruleRequired,

    startViewDisplayImport() {
      this.viewImport = true;
      ImportService.importDisplayData(
        () => {
          Utils.showSuccessSnackbar(this.$t('book/admin:import.snackbar.success'));
          this.viewImport = false;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('book/admin:import.snackbar.failure'));
          this.viewImport = false;
        }
      )
    },

    startExcelImport() {
      if (!this.$refs.excelForm.validate()) {
        return;
      }
      this.viewImport = true;
      ImportService.importExcel(this.file,
        () => {
          Utils.showSuccessSnackbar(this.$t('book/admin:import.snackbar.success'));
          this.viewImport = false;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('book/admin:import.snackbar.failure'));
          this.viewImport = false;
        }
      )
    }

  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    },
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.excelForm.resetValidation();
      });
    }
  },
}

</script>
